export default __webpack_public_path__ + "static/media/logo_transparent_background.5c3138ee.png";